var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeselect',{attrs:{"options":_vm.options,"disable-branch-nodes":true,"show-count":true,"placeholder":"Select..."}})}
var staticRenderFns = []

export { render, staticRenderFns }